<template>
  <div class="case-detail-gene-quality-dailog dialog col-block">
    <div class="title-container row-block">
      <div class="title">{{ 'Quality Control'/* ___ */ }}</div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="data-container col-block" v-for="(variant, vindex) in variants" :key="vindex">
      <div class="data-title-container row-block">
        <div class="data-title">{{ variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -' }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '15px' }"></div>
      <div class="data-content-container col-block">
        <div class="data-row row-block stretch">
          <div class="data-col col-block" v-for="(option, oindex) in tableOption" :key="oindex" :class="[option.position]" :style="option.width ? { width: option.width } : { flex: 1 }">
            <div :style="{ flex: 1 }"></div>
            <div class="data-content" v-html="option.title"></div>
            <div :style="{ flex: 1 }"></div>
          </div>
        </div>
        <div class="data-row row-block stretch">
          <div class="data-col col-block" v-for="(option, oindex) in tableOption" :key="oindex" :class="[option.position]" :style="option.width ? { width: option.width } : { flex: 1 }">
            <div :style="{ flex: 1 }"></div>
            <div v-if="option.value === 'genotype'" class="data-content quality-col genotype-container col-block" :class="{ alert: false }">
              <div class="quality-value-block row-block">
                <div class="quality-value">{{ variant.GT_raw || variant.GT || 'N/A' }}</div>
              </div>
              <div :style="{ height: '0px' }"></div>
              <div class="pass-info-block row-block">
                <img :src="require('../../assets/images/quality-pass-info-icon.svg')" alt="" :style="{ width: '16px', opacity: 0 }">
              </div>
            </div>
            <div v-else-if="option.value === 'readDepth'" class="data-content quality-col readDepth-container col-block" :class="{ alert: option.info && (variant.DP || 0) < 10 }">
              <div class="quality-value-block row-block">
                <div class="quality-value">{{ variant.DP || 0 }}</div>
              </div>
              <template v-if="option.info">
                <div :style="{ height: '0px' }"></div>
                <div class="pass-info-block row-block">
                  <img :src="require('../../assets/images/quality-' + ((variant.DP || 0) < 10 ? 'nopass' : 'pass') + '-info-icon.svg')" alt="" :style="{ width: '16px' }">
                  <div :style="{ width: '5px' }"></div>
                  <div class="pass-info" v-html="(variant.DP || 0) < 10 ? 'Read depth < 10, no pass.'/* ___ */ : 'Read depth ≥ 10, pass.'/* ___ */"></div>
                  <div :style="{ flex: 1 }"></div>
                </div>
              </template>
            </div>
            <div v-else-if="option.value === 'alleleFractions'" class="data-content quality-col alleleFractions-container col-block" :class="{ alert: option.info && ((variant.GT_AF || 0) < 0.25 && ['heterozygosity'].includes(variant.GT)) || ((variant.GT_AF || 0) >= 0.85 && ['heterozygosity'].includes(variant.GT)) || ((variant.GT_AF || 0) < 0.9 && ['homozygosity', 'hemizygosity'].includes(variant.GT)) }">
              <div class="quality-value-block row-block">
                <div class="quality-value">{{  variant.GT_AF ? variant.GT_AF.toFixed(3).replace(/0+$/, '').replace(/\.$/, '') : 0 }}</div>
                <div :style="{ width: '3px' }"></div>
                <div class="quality-desc">{{ '(REF:' + (variant.RD || 0) + ' | ALT:' + (variant.AD || 0) + ')' }}</div>
              </div>
              <template v-if="option.info">
                <div :style="{ height: '0px' }"></div>
                <div class="pass-info-block row-block">
                  <img :src="require('../../assets/images/quality-' + (((variant.GT_AF || 0) < 0.25 && ['heterozygosity'].includes(variant.GT)) || ((variant.GT_AF || 0) >= 0.85 && ['heterozygosity'].includes(variant.GT)) || ((variant.GT_AF || 0) < 0.9 && ['homozygosity', 'hemizygosity'].includes(variant.GT)) ? 'nopass' : 'pass') + '-info-icon.svg')" alt="" :style="{ width: '16px' }">
                  <div :style="{ width: '5px' }"></div>
                  <div class="pass-info" v-html="((variant.GT_AF || 0) < 0.25 && ['heterozygosity'].includes(variant.GT)) || ((variant.GT_AF || 0) >= 0.85 && ['heterozygosity'].includes(variant.GT)) || ((variant.GT_AF || 0) < 0.9 && ['homozygosity', 'hemizygosity'].includes(variant.GT)) ? 'Fractions no pass.'/* ___ */ : 'Fractions pass.'/* ___ */"></div>
                  <div :style="{ flex: 1 }"></div>
                </div>
              </template>
            </div>
            <div v-else-if="option.value === 'genotypeQuality'" class="data-content quality-col genotypeQuality-container col-block" :class="{ alert: option.info && (variant.GQ || 0) < 20 }">
              <div class="quality-value-block row-block">
                <div class="quality-value">{{ variant.GQ || 0 }}</div>
              </div>
              <template v-if="option.info">
                <div :style="{ height: '0px' }"></div>
                <div class="pass-info-block row-block">
                  <img :src="require('../../assets/images/quality-' + ((variant.GQ || 0) < 20 ? 'nopass' : 'pass') + '-info-icon.svg')" alt="" :style="{ width: '16px' }">
                  <div :style="{ width: '5px' }"></div>
                  <div class="pass-info" v-html="(variant.GQ || 0) < 20 ? 'Quality < 20, no pass.'/* ___ */ : 'Quality ≥ 20, pass.'/* ___ */"></div>
                  <div :style="{ flex: 1 }"></div>
                </div>
              </template>
            </div>
            <div v-else-if="option.value === 'geneCoverage'" class="data-content quality-col geneCoverage-container col-block" :class="{ alert: false }">
              <template v-if="Object.keys(getCovGene(variant)).length">
                <div class="quality-value-block row-block" v-for="(option, index) in option.options || []" :key="index">
                  <div class="quality-value">{{ option.title + ': ' + fixNumber(getCovGene(variant)[option.value] * 100, 0.01) + '%' }}</div>
                </div>
              </template>
              <template v-else>
                <div class="quality-value-block row-block">
                  <div class="quality-value">{{ '- -' }}</div>
                </div>
                <div :style="{ height: '0px' }"></div>
                <div class="pass-info-block row-block">
                  <img :src="require('../../assets/images/quality-pass-info-icon.svg')" alt="" :style="{ width: '16px', opacity: 0 }">
                </div>
              </template>
            </div>
            <div v-else class="data-content" :style="option.color ? { color: option.color(variant) } : {}" v-html="option.value || option.empty || '- -'"></div>
            <div :style="{ flex: 1 }"></div>
          </div>
        </div>
      </div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ 'Return'/* ___ */ }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { fixNumber } from '../../constants/global/util'

export default {
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    // param
    gene () {
      return this.param.gene
    },
    variants () {
      return this.param.variants
    },
    coverages () {
      return this.param.coverages
    },
    // static
    tableOption () {
      return (this.gene.SYMBOL || '').startsWith('MT-') ? [
        {
          title: 'Read depth'/* ___ */,
          value: 'readDepth',
          color: null,
          width: null,
          info: false,
          position: 'center',
          empty: 'N/A'/* ___ */
        },
        {
          title: 'Allele Fractions'/* ___ */,
          value: 'alleleFractions',
          color: null,
          width: null,
          info: false,
          position: 'center',
          empty: 'N/A'/* ___ */
        },
        {
          title: 'Gene Coverage(CDS)'/* ___ */,
          value: 'geneCoverage',
          color: null,
          width: null,
          options: [
            { title: '2000X', value: 'x2000_cov' },
            { title: '3000X', value: 'x3000_cov' }
          ],
          position: 'center',
          empty: 'N/A'/* ___ */
        }
      ] : [
        {
          title: 'Genotype'/* ___ */,
          value: 'genotype',
          color: null,
          width: null,
          position: 'center',
          empty: 'N/A'/* ___ */
        },
        {
          title: 'Read depth'/* ___ */,
          value: 'readDepth',
          color: null,
          width: null,
          info: true,
          position: 'center',
          empty: 'N/A'/* ___ */
        },
        {
          title: 'Allele Fractions'/* ___ */,
          value: 'alleleFractions',
          color: null,
          width: null,
          info: true,
          position: 'center',
          empty: 'N/A'/* ___ */
        },
        {
          title: 'Genotype Quality'/* ___ */,
          value: 'genotypeQuality',
          color: null,
          width: null,
          info: true,
          position: 'center',
          empty: 'N/A'/* ___ */
        },
        {
          title: 'Gene Coverage(CDS)'/* ___ */,
          value: 'geneCoverage',
          color: null,
          width: null,
          options: [
            { title: '10X', value: 'x10_cov' },
            { title: '20X', value: 'x20_cov' }
          ],
          position: 'center',
          empty: 'N/A'/* ___ */
        }
      ]
    },
    // global
    fixNumber () { return fixNumber }
  },
  methods: {
    getCovGene (variant) {
      let result = (((this.coverages['coding_exon'] || {})[(this.gene.SYMBOL || '')] || {}).transcripts || {})[(variant.Feature || '').replace(/\.\d$/, '')] || (((this.coverages['all_exon'] || {})[(this.gene.SYMBOL || '')] || {}).transcripts || {})[(variant.Feature || '').replace(/\.\d$/, '')] || {}
      return result || {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/caseDetailGeneQuality.vue